/**
 * BudgetTransactionSourceService
 * Service for BudgetTransactionSource lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for BudgetTransactionSource CRUD operations */
export class BudgetTransactionSourceService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BudgetTransactionSourceService.DEFAULT_SERVICE_PATH,
            basePath: BudgetTransactionSourceService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BudgetTransactionSourceService.DEFAULT_SERVICE_PATH = 'budgets';
BudgetTransactionSourceService.BASE_PATH = 'api/budgettransactionsources';
//# sourceMappingURL=BudgetTransactionSourceService.js.map